import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import VolunteerSidebar from "./VolunteerSidebar";
import LogoutWatcher from "../../Utils/LogoutWatcher";
import Header from "../Utils/Header";
import { useGlobalContext } from "../../../GlobalContext";

export default function VolunteerLayout() {
  // ============================================================
  // SIDEBAR STATE - PERSIST ACROSS NAVIGATION
  // ============================================================

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const savedState = sessionStorage.getItem("packky_volunteer_sidebar");

    return savedState !== null ? savedState === "true" : true;
  });

  const { showOld, setShowOld } = useGlobalContext();

  // ============================================================
  // SAVE SIDEBAR STATE
  // ============================================================

  useEffect(() => {
    sessionStorage.setItem("packky_volunteer_sidebar", String(sidebarOpen));
  }, [sidebarOpen]);

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Logout Watcher */}
      <LogoutWatcher type="volunteer" />

      {/* Sidebar */}
      <VolunteerSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Right Section */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header showOld={showOld} setShowOld={setShowOld} />

        {/* Page Content */}
        <div className="flex-1 overflow-auto p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
